import React from 'react';

import { useCheckPermission } from './hooks';
import { NotFoundError } from './components/NotFoundError';
import type { AdminPermissionKey } from '@duke-hq/svc-iam-policy';
import { Center } from '@chakra-ui/layout';

export function withPermission<P extends object = object>(
  permissionId: AdminPermissionKey,
  Component: React.ComponentType<P>,
) {
  function WrappedComponent(props: P) {
    const hasPermission = useCheckPermission(permissionId);
    if (!hasPermission) {
      return (
        <Center mt={4}>
          <NotFoundError />
        </Center>
      );
    }
    return <Component {...props} />;
  }
  let componentName = '';
  if (typeof Component.displayName === 'string' && Component.displayName !== '') {
    componentName = Component.displayName;
  } else {
    if (typeof Component.name === 'string' && Component.name !== '') {
      componentName = Component.name;
    } else {
      componentName = 'Component';
    }
  }
  WrappedComponent.displayName = `WithPermission(${componentName})`;
  return WrappedComponent;
}
